import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import { NavLink } from 'react-router-dom';

var bnrimg = require('../../images/banner/faq.png');

class Faq extends React.Component {
    render() {
        return (
            <>
                <Header />
                <div className="page-content">
                    <Banner title="Preguntas Frecuentes" pagename="Faq" description="Construyendo con visión, administrando con excelencia." bgimage={bnrimg}/>
                    {/* SECTION CONTENT START */}
                    <div className="section-full p-t80 p-b80 inner-page-padding">
                        <div className="container">
                            <div className="faq-1">
                                {/* TITLE START */}
                                <div className="section-head">
                                    <div className="sx-separator-outer separator-center">
                                        <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(images/background/cross-line2.png)' }}>
                                            <h3 className="sep-line-one">FAQ</h3>
                                        </div>
                                    </div>
                                </div>
                                {/* TITLE END */}
                                <div className="row">
                                    <div className="col-md-6 faq-list">
                                        {/* Accordian */}
                                        <div>
                                            <h4>¿Tienes dudas?</h4>
                                            <p>Revisa la sección de preguntas frecuentes.</p>
                                        </div>
                                        <div>
                                            <h4>¿Dónde comunicarte en caso de no encontrar respuesta en la sección de FAQ?</h4>
                                            <p>Tenemos diferentes canales de comunicación, en los cuales, en caso de tener dudas específicas, puedes contactarnos.</p>
                                        </div>
                                        <div>
                                            <h4>¿Qué canales de comunicación?</h4>
                                            <p>Tenemos distintos canales de comunicación, dirígete a:</p>
                                            <h4><NavLink to="/contact-us">Contáctanos</NavLink></h4>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        {/* Accordian */}
                                        <div className="sx-accordion acc-bg-gray" id="accordion5">
                                            <div className="panel sx-panel">
                                                <div className="acod-head acc-actives">
                                                    <h4 className="acod-title">
                                                        <a data-toggle="collapse" href="#collapseOne5" data-parent="#accordion5">
                                                            ¿Cómo trabajamos?
                                                            <span className="indicator"><i className="fa fa-plus" /></span>
                                                        </a>
                                                    </h4>
                                                </div>
                                                <div id="collapseOne5" className="acod-body collapse show">
                                                    <div className="acod-content p-a15">
                                                        <p>Fomentamos el trabajo en equipo con iniciativas compatibles con estándares. Monetizamos eficientemente la subcontratación con comunidades de excelencia.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel sx-panel">
                                                <div className="acod-head">
                                                    <h4 className="acod-title">
                                                        <a data-toggle="collapse" href="#collapseTwo5" className="collapsed" data-parent="#accordion5">
                                                            ¿Qué servicios ofrecemos?
                                                            <span className="indicator"><i className="fa fa-plus" /></span>
                                                        </a>
                                                    </h4>
                                                </div>
                                                <div id="collapseTwo5" className="acod-body collapse">
                                                    <div className="acod-content p-a15"><p>Administración de proyectos arquitectónicos y de construcción.</p></div>
                                                </div>
                                            </div>
                                            <div className="panel sx-panel">
                                                <div className="acod-head">
                                                    <h4 className="acod-title">
                                                        <a data-toggle="collapse" href="#collapseThree5" className="collapsed" data-parent="#accordion5">
                                                            ¿Cómo protegemos tus datos?
                                                            <span className="indicator"><i className="fa fa-plus" /></span>
                                                        </a>
                                                    </h4>
                                                </div>
                                                <div id="collapseThree5" className="acod-body collapse">
                                                    <div className="acod-content p-a15"><p>Utilizamos bases de datos únicas que garantizan la seguridad de los datos de cada uno de nuestros clientes.</p></div>
                                                </div>
                                            </div>
                                            <div className="panel sx-panel">
                                                <div className="acod-head">
                                                    <h4 className="acod-title">
                                                        <a data-toggle="collapse" href="#collapseFour5" className="collapsed" data-parent="#accordion5">
                                                            ¿Cómo almacenamos tus datos?
                                                            <span className="indicator"><i className="fa fa-plus" /></span>
                                                        </a>
                                                    </h4>
                                                </div>
                                                <div id="collapseFour5" className="acod-body collapse">
                                                    <div className="acod-content p-a15"><p>Cada cliente cuenta con una base de datos única con accesos exclusivos.</p></div>
                                                </div>
                                            </div>
                                            <div className="panel sx-panel">
                                                <div className="acod-head">
                                                    <h4 className="acod-title">
                                                        <a data-toggle="collapse" href="#collapseFive5" className="collapsed" data-parent="#accordion5">
                                                            ¿Cuánto tiempo dura la base de datos?
                                                            <span className="indicator"><i className="fa fa-plus" /></span>
                                                        </a>
                                                    </h4>
                                                </div>
                                                <div id="collapseFive5" className="acod-body collapse">
                                                    <div className="acod-content p-a15">
                                                        <p>Las bases de datos tienen una duración de cinco días posteriores a la baja del servicio. Una vez transcurrido este periodo, la base de datos y toda la información almacenada serán eliminadas.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel sx-panel">
                                                <div className="acod-head">
                                                    <h4 className="acod-title">
                                                        <a data-toggle="collapse" href="#collapseSix5" className="collapsed" data-parent="#accordion5">
                                                            ¿Cómo accedo a la plataforma?
                                                            <span className="indicator"><i className="fa fa-plus" /></span>
                                                        </a>
                                                    </h4>
                                                </div>
                                                <div id="collapseSix5" className="acod-body collapse">
                                                    <div className="acod-content p-a15">
                                                        <p>Una vez realizado el pago del servicio, se creará una base de datos única, junto con un usuario maestro y una contraseña temporal para acceder a la plataforma.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="panel sx-panel">
                                                <div className="acod-head">
                                                    <h4 className="acod-title">
                                                        <a data-toggle="collapse" href="#collapseSix5" className="collapsed" data-parent="#accordion5">
                                                            Como obtengo manuales y documentación?
                                                            <span className="indicator"><i className="fa fa-plus" /></span>
                                                        </a>
                                                    </h4>
                                                </div>
                                                <div id="collapseSix5" className="acod-body collapse">
                                                    <div className="acod-content p-a15">
                                                        <p>En la platafomra de SoltArc en la sección de ayuda esta todo lo relacionado a manuales, documentación y de ser necesario una burbaja para chatear con un agente</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* SECTION CONTENT END */}
                </div>
                <Footer />
            </>
        );
    }
};

export default Faq;
